export class TableMeta {
    // Config to show or hide global search of table
    displayGlobalSearch?: boolean;

    // Config to show or hide check boxes
    displayCheckBox?: boolean;

    // Config to show or hide context menu
    displayContextMenu?: boolean;

    // Config to show or hide kebab menu
    displayKebabMenu?: boolean;

    // Config to show or hide edit menu and delete option in context and kebab
    // (one of this should be enabled if kebab or context is enabled)
    displayEditMenu?: boolean;
    displayDeleteMenu?: boolean;

    // Config for hiding Pagination
    hidePagination?: boolean;

    // Config to show account search
    showAccountSearch?: boolean;

    // Config to show create button or not
    displayCreateButton?: boolean;

    // Config to differentiate between customer user and internal user
    isCustomerUser?: boolean;

    // Config to disable server side filtering and use client side filtering
    useClientSideFiltering?: boolean;

    // Config to display upload button
    displayUploadButton?: boolean;

    // Config to display download button
    displayDownloadButton?: boolean;
}
